import { useState } from "react";
import { useTours } from "@/lib/siteData";
import { supabase, uploadSiteImage } from "@/lib/supabase";
import { money, useAdminRows, isUuid } from "@/lib/booking";
import { Card, Field, SaveBtn, Ok, Err, MultiCheck, SubTitle, useAction, smallBtn } from "./adminUI";

const EMPTY = { title: "", description: "", price: "", max_quantity: 1, image_url: "", tour_ids: [] };

export default function AddonsAdmin() {
    const tours = useTours(true).filter((t) => isUuid(t.id));
    const addons = useAdminRows("addons", (sb) => sb.from("booking_addons").select("*").order("sort_order"));
    const [f, setF] = useState(EMPTY);
    const { run, busy, msg, err } = useAction();
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));
    const tourOpts = tours.map((t) => [t.id, t.title]);

    const create = () => run(async () => {
        if (!f.title.trim() || f.price === "") throw new Error("Informe nome e preço.");
        const r = await supabase.from("booking_addons").insert({ ...f, title: f.title.trim(), price: Number(f.price),
            max_quantity: Number(f.max_quantity) || 1, tour_ids: f.tour_ids.length ? f.tour_ids : null });
        if (!r.error) setF(EMPTY);
        return r;
    });
    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (file) run(async () => set("image_url")(await uploadSiteImage(file, "addons")), "Imagem enviada");
    };

    return (
        <Card className="space-y-5" >
            <SubTitle>Adicionais (vendidos somente dentro de uma reserva)</SubTitle>
            <div className="grid gap-4 sm:grid-cols-2" data-testid="addons-admin">
                <Field label="Nome" value={f.title} onChange={set("title")} testid="addon-title" />
                <Field label="Preço (R$)" type="number" value={f.price} onChange={set("price")} testid="addon-price" />
                <Field label="Descrição" value={f.description} onChange={set("description")} />
                <Field label="Quantidade máxima" type="number" value={f.max_quantity} onChange={set("max_quantity")} />
                <Field label="URL da imagem" value={f.image_url} onChange={set("image_url")} />
                <label className="block text-xs text-dim">Enviar imagem<input type="file" accept="image/*" onChange={upload} className="mt-2 block text-xs" /></label>
            </div>
            <MultiCheck label="Compatível com (vazio = todas)" options={tourOpts} value={f.tour_ids} onChange={set("tour_ids")} />
            <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} /><SaveBtn onClick={create} saving={busy} testid="addon-create">Cadastrar adicional</SaveBtn></div>
            {(addons.data || []).map((a) => (
                <div key={a.id} className="flex flex-wrap items-center justify-between gap-3 border-t border-ink/10 pt-3">
                    <div className="flex items-center gap-3">
                        {a.image_url && <img src={a.image_url} alt="" className="h-10 w-10 rounded-lg object-cover" />}
                        <div><strong>{a.title}</strong><p className="text-xs text-dim">{money(a.price)} · máx. {a.max_quantity} · {a.tour_ids?.length ? `${a.tour_ids.length} experiência(s)` : "todas"} · {a.active ? "Ativo" : "Inativo"}</p></div>
                    </div>
                    <div className="flex gap-2">
                        <button className={smallBtn} disabled={busy} onClick={() => run(() => supabase.from("booking_addons").update({ active: !a.active }).eq("id", a.id))}>{a.active ? "Desativar" : "Ativar"}</button>
                        <button className={smallBtn} disabled={busy} onClick={() => window.confirm("Excluir adicional?") && run(() => supabase.from("booking_addons").delete().eq("id", a.id))}>Excluir</button>
                    </div>
                </div>
            ))}
        </Card>
    );
}
